import { render, staticRenderFns } from "./CardsListVo.vue?vue&type=template&id=bf46c736&scoped=true&"
import script from "./CardsListVo.vue?vue&type=script&lang=js&"
export * from "./CardsListVo.vue?vue&type=script&lang=js&"
import style0 from "./CardsListVo.vue?vue&type=style&index=0&id=bf46c736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf46c736",
  null
  
)

export default component.exports